// No translation header text
export const notAvailableText = 'Traducción no disponible';
export const answerInEnglishText =
  'Escribe tus respuestas en inglés de acuerdo con las instrucciones de la pregunta.';
export const btnDisabledWarning =
  'Las traducciones al español deben estar "desactivadas" para poder responder a esta pregunta.';

// Student Assignment View text
export const instructions = 'Instrucciones';
export const answerOptions = 'Opciones de respuesta';

export const eliminationToolText = 'Herramienta de eliminación';
export const hideEliminatedAnswersText = 'Ocultar respuestas eliminadas';
export const showEliminatedAnswersText = 'Mostrar respuestas eliminadas';

const selectInstructions = 'Selecciona todas las que correspondan';
const selectOneInstructions = 'Selecciona una respuesta';
const freeResponseInstructions = 'Proporciona tu respuesta a continuación';
const freeEntryInstructions = 'Responda la siguiente pregunta:';
const dropdownInstructions = 'Selecciona las opciones de la lista';
const passageCorrectionInstructions =
  ' Haz clic en la(s) palabra(s) que quieras editar en la oración de abajo y escribe tus cambios';
const freeEntryInputInstructions = 'Escribe la respuesta aquí. Presta atención a la ortografía.';
const freeEntryMathInputInstructions =
  'Ingrese la respuesta aquí. No incluya espacios ni unidades.'; // TODO 'Enter answer here. Do not include spaces or units.'
const highlightInstructions = 'Resalte la(s) respuesta(s) a continuación';
export const translatedInstructions = {
  freeResponse: freeResponseInstructions,
  freeEntry: freeEntryInstructions,
  freeEntryInput: freeEntryInputInstructions,
  freeEntryMathInput: freeEntryMathInputInstructions,
  passageCorrection: passageCorrectionInstructions,
  highlight: highlightInstructions,
  selectMultiple: selectInstructions,
  selectOne: selectOneInstructions,
  dropdown: dropdownInstructions
} as const;

export const Explanation = 'Explicación';
export const CorrectAnswers = 'Respuesta(s) Correcta(s)';

export const graphingInstructions = {
  'Add point': 'Agregar punto',
  'Add line': 'Agregar línea',
  'Add segment': 'Agregar segmento',
  'Add ray': 'Agregar rayo',
  'Add polygon': 'Agregar polígono',
  'Add circle': 'Agregar círculo',
  'Add inequality': 'Agregar desigualdad',
  'Add parabola': 'Agregar parábola'
} as const;

export const addMediaText = {
  button: 'Agregar medios',
  image: 'Imagen',
  audio: 'Audio'
};
